import { useCallback } from "react";

import { prefetchPath } from "@/routes/prefetch";

/**
 * Returns a stable callback that warms the lazy-loaded chunk for `href`.
 *
 * Usage on a react-aria-components Link / ButtonLink / IconButtonLink:
 *   const prefetch = usePrefetchOnHover(href);
 *   <ButtonLink href={href} onHoverStart={prefetch} onFocus={prefetch} … />
 *
 * Usage on a plain DOM element (or a wrapper around components that don't
 * forward Aria events yet):
 *   <div onPointerEnter={prefetch} onFocus={prefetch}>…</div>
 *
 * External hrefs (`http(s)`, `mailto:`, `tel:`, `#`) and unknown paths no-op.
 */
export const usePrefetchOnHover = (href: string | null | undefined) =>
  useCallback(() => {
    prefetchPath(href);
  }, [href]);
